import React, { Component } from "react";
import { Flex, List, WhiteSpace } from 'antd-mobile';
import { Carousel } from 'antd';
import { Link } from "react-router-dom";
import { NavBar } from 'antd-mobile';
import Citychange from '../common/city';
import * as services from '../projects/services';
import { HospitalItems } from '../hospital/item';
import { createBrowserHistory } from "history";
import * as fun from '../../components/common';
import "../../utils/tool.jsx";
import '../home/style.less'
let page = 1;
let rows = 5;
let total = 0;
let parameter = {
    page: page, //：页码
    rows: rows, //每页条数
    level: '',//医院等级 –查询条件
    county: '', //区域名称
    isenable: '',  //是否联盟: 1是，其他否
    city: ''
}
const Itema = List.Item;
const history = createBrowserHistory();
export class HomeItem extends Component {
    constructor(props) {
        if (!window.globalvariable.getStore('cityid')) {
            window.globalvariable.setStore('cityid', global.constants.cityid);
        }
        parameter = {
            page: page, //：页码
            rows: rows, //每页条数
            level: '',//医院等级 –查询条件
            county: '', //区域名称
            isenable: '',  //是否联盟: 1是，其他否
            city: window.globalvariable.getStore('cityid')
        }
        super(props);
        this.state =
        {
            hospitalListDatas: [],
            bannerList: [],
            wxmapList: [],
            parameter: parameter,
            city: window.globalvariable.getStore('cityid'),
        }
    }
    componentDidMount() {
        this.GetPageMidcailCenter();
        this.GetadvertisementList();
        this.GetadvertisementList2();
        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total / rows >= page) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }

            timeCount = setTimeout(callback, 50);
        }.bind(this), false);
    }
    //再次加载
    loadMoreDataFn = (page) => {
        parameter.page = page;
        this.setState({
            parameter: parameter,
        });
        services.GetPageMidcailCenter(this.state.parameter, '正在查询，请稍后').then(value => {
            if (value.status === 0) {
                this.setState({
                    hospitalListDatas: this.state.hospitalListDatas.concat(value.result.rows),
                });
            }
        })
    }
    getChildInfo = (name) => {
        this.setState({ city: name.children, value: name.value });
        window.globalvariable.setStore('cityid', name.value);
    }
    //获取体检中心列表
    // //获取医院列表
    GetPageMidcailCenter = () => {
        page = 1;
        parameter = {
            page: page, //：页码
            rows: rows, //每页条数
            level: '',//医院等级 –查询条件
            county: '', //区域名称
            isenable: '',  //是否联盟: 1是，其他否
            city: window.globalvariable.getStore('cityid')
        }
        services.GetPageMidcailCenter(parameter, '正在查询，请稍后').then(value => {
            if (value.status === 0) {
                total = value.result.total;
                this.setState({ hospitalListDatas: value.result.rows, }, () => {

                });
            }
        })
    }
    //获取首页轮播图
    GetadvertisementList = () => {
        services.GetadvertisementList(global.advertisement.advertisement_wxbanner, '').then(data => {
            if (data.status === 0) {
                this.setState({ bannerList: data.result });
            }
        });
    }
    //获取首页广告图
    GetadvertisementList2 = () => {
        services.GetadvertisementList(global.advertisement.advertisement_wxmap, '').then(data => {
            if (data.status === 0) {
                this.setState({ wxmapList: data.result });
            }
        });
    }
      //链接跳转
      openlink =(data,e) =>
      {
          if(!!data)
          {
              if(fun.IsWebsite(data.link) )
              {            
                  window.location.href = fun.IsHttp(data.link);
              }else if(data.link !=='' && data.link !=='/')
              {
                  history.push(data.link);
                  history.go();
              }
          }
      }
    render() {
        const history = createBrowserHistory();
        return (

            <div>
                <div style={{ display: "block", width: "100%", position: "fixed", top: "0px", zIndex: "999" }}>
                    {<NavBar
                        mode="light"
                        rightContent={<Citychange toParent={this.getChildInfo.bind(this)} GetPageMidcailCenter={this.GetPageMidcailCenter} />
                        }
                    ></NavBar>}

                </div>
                <div className="homeitem" >
                    {
                        this.state.bannerList.length > 0 ?
                            <Carousel autoplay className='homeCarousel'>
                                {this.state.bannerList.map((data, index) => (
                                    <div className="advertisement" key={index} >
                                        <img alt={data.title} src={data.picpath} onClick={this.openlink.bind(this, data)} />
                                    </div>
                                ))}
                            </Carousel> : ''
                    }
                    <WhiteSpace size="md" />
                    <div className="indexbox">
                        <Flex >
                            <Link to={'/members/orderment/0'}><img alt='' src={require('../../res/images/i_icon2.png')} /><span className="text1">职工体检</span></Link>
                            <Link to={'/members/orderment/0'}><img alt='' src={require('../../res/images/i_icon3.png')} /><span className="text1">公务员体检</span></Link>
                            <Link to={'/package'}><img alt='' src={require('../../res/images/i_icon1.png')} /><span className="text1">个人体检</span></Link>
                        </Flex>
                    </div>
                    <WhiteSpace size="lg" />
                    <div className="indexbox2">
                        <Flex >
                            <Link to={'/members/report'}><img alt='' src={require('../../res/images/i_icon4.png')} /><span className="text2">报告查询</span></Link>
                            <Link to={'/members/interpret/0'}><img alt='' src={require('../../res/images/i_icon5.png')} /><span className="text2">报告解读</span></Link>
                        </Flex>
                    </div>
                    {/* <WhiteSpace size="lg"  />
                <div className="indexbox3">
                  <div className='linka'>
                        <Link to={'/package'}><img alt='' src={require('../../res/images/g_pic1.jpg')} /></Link>
                    </div>
                    <div className="linkb">
                        <Link to={'/package'}><img alt='' src={require('../../res/images/g_pic2.jpg')} /></Link>
                        <div className="linkd">
                            <Link className="linkc" to={'/package'}><img alt='' src={require('../../res/images/g_pic3.jpg')} /></Link>
                            <Link className="linkc" to={'/package'}><img alt='' src={require('../../res/images/g_pic4.jpg')} /></Link>
                        </div>
                    </div> 
                </div> */}
                    <WhiteSpace size="lg" />
                    {
                        this.state.wxmapList.length > 0 ?
                            <div className="indeximg" >
                                <Link to={this.state.wxmapList[0].link} ><img alt={this.state.wxmapList[0].title} src={this.state.wxmapList[0].picpath} /></Link>

                            </div>
                            : ''
                    }
                    <div className="itemlist">
                        <Itema extra="更多" arrow="horizontal" onClick={() => {
                            history.push('/hospital') // 强制跳转
                            history.go();
                        }}>全市体检中心</Itema>
                        {this.state.hospitalListDatas.map((data, index) => (<HospitalItems hospitalData={data} key={index} />))}
                        <div ref="wrapper"></div>
                    </div>

                </div>
            </div >
        );
    }
}
